import dayjs from 'dayjs';
import { StyledShipmentStepper } from './styled';
import { memo } from 'react';

interface ShipmentStepperProps {
  data: {
    time: string;
    title: string;
  }[];
}

const ShipmentStepper = ({ data }: ShipmentStepperProps) => {
  return (
    <StyledShipmentStepper>
      {data.map(({ time, title }, index) => (
        <li key={index}>
          <time />
          <span>{dayjs(time).format('HH:mm DD-MM-YYYY')}</span>
          <div className="time-info">{title}</div>
        </li>
      ))}
    </StyledShipmentStepper>
  );
};

export default memo(ShipmentStepper);
